import React, { useEffect, useRef, useState } from 'react';

const HighlightText = ({ adText, typedText }) => {
    const [charDimensions, setCharDimensions] = useState({ width: 7.2, height: 16 }); // Default dimensions
    const textRef = useRef(null);

    // Measure character width and height dynamically
    useEffect(() => {
        if (textRef.current) {
            const span = document.createElement('span');
            span.style.visibility = 'hidden';
            span.style.position = 'absolute';
            span.style.whiteSpace = 'pre';
            span.style.font = '16px monospace'; // Match your app's font style
            span.textContent = 'a'; // Use a representative character
            document.body.appendChild(span);
            setCharDimensions({ width: span.offsetWidth, height: span.offsetHeight });
            document.body.removeChild(span);
        }
    }, []);

    const calculateCursorPosition = () => {
        const lines = typedText.split('\n');
        const currentLineIndex = lines.length - 1; // Current line is the last in the array
        const currentLine = lines[currentLineIndex];
        const xPosition = currentLine.length * charDimensions.width;
        const yPosition = currentLineIndex * charDimensions.height;

        return { x: xPosition, y: yPosition };
    };

    const cursorPosition = calculateCursorPosition();
    const cursorOffset = 2; // Adjust this value to line up the cursor with the text

    return (
        <span
            ref={textRef}
            style={{
                position: 'relative',
                display: 'inline-block',
                fontFamily: 'monospace',
                fontSize: '16px',
                lineHeight: `${charDimensions.height}px`, // Ensure line spacing matches
                whiteSpace: 'pre-wrap', // Important for handling line breaks
                color: 'black', // Default text color
            }}
        >
            {adText.split('').map((char, index) => {
                let color = 'black'; // Default color
                if (index < typedText.length) {
                    color = typedText[index] === char ? '#4192D9' : 'red';
                }
                return (
                    <span
                        key={index}
                        style={{
                            color: color, // Change the text color based on typed text
                            whiteSpace: 'pre',
                        }}
                    >
                        {char}
                    </span>
                );
            })}
            <span
                className="cursor"
                style={{
                    position: 'absolute',
                    left: `${cursorPosition.x}px`,
                    top: `${cursorPosition.y + cursorOffset}px`,
                    height: `${charDimensions.height}px`,
                    lineHeight: `${charDimensions.height}px`, // Ensure line spacing matches
                    width: '2px',
                    backgroundColor: 'black',
                    animation: 'blink 0.5s step-end infinite',
                }}
            />
        </span>
    );
};

export default HighlightText;